const AUTH_SUCCESS = 'app/auth/AUTH_SUCCESS'
const AUTH_ERROR = 'app/auth/AUTH_ERROR'

export { AUTH_SUCCESS, AUTH_ERROR }
